import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../services/AuthContext';
import { SectionTitle, Text } from '../Common/PublicLegalPageLayout';
import GuideAccordionSection from './GuideAccordionSection';
import { getFaqSectionsForRole } from '../../utils/supportGuideFaqConfig';

export default function SupportFaqSection() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const role = user?.role || 'guest';
  const roleLabel = t(`supportGuide.roleLabels.${role}`, { defaultValue: role });

  const expandLabel = t('supportGuide.expandSection');
  const collapseLabel = t('supportGuide.collapseSection');
  const faqTitle = t('supportFaq.faqBlockTitle');

  const faqSections = useMemo(
    () => getFaqSectionsForRole(role).map(({ sectionId, faqKeys }) => ({
      sectionId,
      title: t(`supportGuide.sections.${sectionId}.title`),
      intro: t(`supportFaq.sections.${sectionId}.intro`, {
        defaultValue: t(`supportGuide.sections.${sectionId}.presentation`, { defaultValue: '' })
      }),
      faqItems: faqKeys
        .map((key) => ({
          key,
          q: t(`supportFaq.items.${key}.q`, { defaultValue: '' }),
          a: t(`supportFaq.items.${key}.a`, { defaultValue: '' })
        }))
        .filter((item) => item.q && item.a)
    })),
    [role, t]
  );

  return (
    <>
      <SectionTitle>{t('supportFaq.title')}</SectionTitle>
      <Text>{t('supportFaq.intro')}</Text>
      <Text style={{ marginBottom: '0.75rem', fontWeight: 600 }}>
        {t('supportFaq.roleBanner', { role: roleLabel })}
      </Text>
      <Text style={{ marginBottom: '1rem', opacity: 0.9, fontSize: '0.95rem' }}>
        {t('supportFaq.accordionHint')}
      </Text>

      {faqSections.map((section, index) => (
        <GuideAccordionSection
          key={section.sectionId}
          id={`faq-${section.sectionId}`}
          title={section.title}
          presentation={section.intro}
          faqItems={section.faqItems}
          faqTitle={faqTitle}
          defaultOpen={index === 0}
          expandLabel={expandLabel}
          collapseLabel={collapseLabel}
        />
      ))}
    </>
  );
}
